module.exports = __webpack_public_path__ + "img/1518397412.96a8f552.jpg";